// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__4R3eI","content":"index_content__qjXyR"};